import React from 'react';
import _ from 'lodash';

/**
 * @description ソートしたときのボタンを表示する
 * @param {string} sortType Paramsの order の文字列
 * @param {string} name ソートするkey名
 *  name = 'company_name'
 *  sortType = 'company_name_asc' の場合 A→Zのアイコン表示
 *  sortType = 'company_name_desc' の場合 Z→Aのアイコン表示
 *  sortType = その他 の場合 アイコン表示なし
 */
const getSortButton = (sortType, name) => {
  if (!_.isString(sortType)) {
    // console.log(sortType);
    throw new Error('getSortButton args 1 sortType');
  }

  if (sortType === `${name}_asc`) {
    return (
      <button className='btn-icon--xs--dark'>
        <i className='i-sortaz i-1x' />
      </button>
    );
  } else if (sortType === `${name}_desc`) {
    return (
      <button className='btn-icon--xs--dark'>
        <i className='i-sortza i-1x' />
      </button>
    );
  } else {
    return null;
  }
};

/**
 * @description ソート関数用文字コード比較関数
 *  array.sort に渡す関数で使用する
 * @param {string} str1 比較関数用引数
 * @param {string} str2 比較関数用引数
 */
const stringSortCompareAsc = (str1, str2) => {
  const charCode = str => {
    return str ? str.charCodeAt(0) : 0;
    // 空文字の時は 0 と判定する。(そうしないと正しく動作しない)
  };
  if (charCode(str1) < charCode(str2)) {
    return -1;
  }
  if (charCode(str1) > charCode(str2)) {
    return 1;
  }
  return 0;
};

const stringSortCompareDesc = (str1, str2) => {
  return -1 * stringSortCompareAsc(str1, str2);
};

export { getSortButton, stringSortCompareAsc, stringSortCompareDesc };



// WEBPACK FOOTER //
// ./src/utilities/sortUtility.js